<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="我发布的">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
          <h3 style="margin: 0;">活动管理</h3>
          <el-button type="text" icon="el-icon-plus" @click="$router.push('/admin/createactivity')">发布新的活动</el-button>
        </div>
        <el-table :data="myList" border>
          <el-table-column label="日期" width="170">
            <template slot-scope="scope">{{ scope.row.createtime | dataFormat }}</template>
          </el-table-column>
          <el-table-column label="标题" prop="activity_title"></el-table-column>
          <el-table-column label="类型" prop="activity_lable" width="120"></el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="$router.push(`/admin/updateactivity/${scope.row.activity_id}`)">编辑</el-button>
              <el-button type="text" style="color: #f56c6c;" @click="del(scope.row.activity_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 12px;">
          <el-pagination layout="prev, pager, next" :total="myTotal" :page-size="10" @current-change="getMy"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我参加的">
        <el-table :data="joinList" border>
          <el-table-column label="报名日期" width="170">
            <template slot-scope="scope">{{ scope.row.jions_createtime | dataFormat }}</template>
          </el-table-column>
          <el-table-column label="标题" prop="activity_title"></el-table-column>
          <el-table-column label="类型" prop="activity_lable" width="120"></el-table-column>
          <el-table-column label="操作" width="180" fixed="right">
            <template slot-scope="scope">
              <a :href="`${url}/#/activitycontent/${scope.row.activity_id}`" target="_blank" style="color: #0E7490; font-size: 13px; margin-right: 10px;">查看</a>
              <el-button type="text" style="color: #f56c6c;" @click="deljoin(scope.row.join_id)">取消报名</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getMyActivityList, deleteActivity, getJoinsList, deleteJoin } from '@/api'

export default {
  name: 'CreateActivityList',
  data() {
    return { myList: [], myTotal: 0, joinList: [] }
  },
  computed: {
    ...mapState({ url: (s) => s.url })
  },
  created() {
    this.getMy(1)
    this.getJoins()
  },
  methods: {
    getMy(page) {
      getMyActivityList({ page, pagesize: 10 }).then((res) => {
        this.myList = res.data || []
        this.myTotal = res.count || 0
      })
    },
    getJoins() {
      getJoinsList('activitycontent').then((res) => {
        this.joinList = res.data || []
      })
    },
    del(id) {
      this.$confirm('确定删除该活动吗？', '提示', { type: 'warning' }).then(() => {
        deleteActivity(id).then(() => {
          this.$message.success('删除成功')
          this.getMy(1)
        })
      }).catch(() => {})
    },
    deljoin(id) {
      deleteJoin(id).then(() => {
        this.$message.success('已取消报名')
        this.getJoins()
      })
    }
  }
}
</script>
